import { IconButton } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import { IcDotSpread } from '@/assets/images';
import { IInventoryLocation } from '@/models/inventory.locations';

const name = (): Partial<GridColDef> => ({
  renderCell: (params) => params.row.name || '-',
});

const type = (): Partial<GridColDef> => ({
  field: 'type.name',
  renderCell: (params) => params.row.type?.name || '-',
  valueGetter: (_value, row) => row.type?.name,
});

const parent = (): Partial<GridColDef> => ({
  field: 'parent.name',
  renderCell: (params) => params.row.parent?.name || '-',
  valueGetter: (_value, row) => row.parent?.name,
});

const actions = (
  openMenu?: (
    event: React.MouseEvent<HTMLButtonElement>,
    param: IInventoryLocation,
  ) => void,
): Partial<GridColDef> => ({
  sortable: false,
  filterable: false,
  renderCell: (params) => (
    <IconButton
      onClick={(e) => {
        e.stopPropagation();
        openMenu?.(e, params.row);
      }}
    >
      <IcDotSpread />
    </IconButton>
  ),
});

export const agencyInventoryLocationCols = (
  openMenu?: (
    event: React.MouseEvent<HTMLButtonElement>,
    param: IInventoryLocation,
  ) => void,
) => {
  return {
    name,
    type,
    parent,
    actions: () => actions(openMenu),
  };
};
